<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <template v-if="available_company_accounts.length >= 1">
            <v-row no-gutters>
                <v-col class="mb-1 d-flex align-start">
                    <ModernFilterBar :filter-controller="filterController" />
                    <div
                        v-if="selected_account && can_edit_account(selected_account.id) && !selected_account.data.is_demo"
                        class="pa-2 g3 d-flex align-center"
                        style="border-radius: 8px"
                    >
                        <div class="body-1 mx-4">
                            {{ $t('You have invited {0}/{1} members').format(activeTotalMembers ? activeTotalMembers : 0, paidForUsersCount) }}
                        </div>
                        <primary-button @click="$router.push({ name: 'subscription_choose_plan', params: { id: selectedCompanyId }})">
                            {{ $t('Upgrade') }}
                        </primary-button>
                    </div>
                </v-col>
            </v-row>

            <v-row class="pr-4">
                <v-col class="d-flex align-center pb-0">
                    <v-tabs
                        :value="tabs.findIndex(x => x.value === selectedTab)"
                        style="width: auto"
                        background-color="transparent"
                        class="denser-tabs flex-grow-0"
                        slider-size="4"
                    >
                        <v-tab
                            v-for="tab in tabs"
                            :key="tab.value"
                            @click="onTabSelected(tab.value)"
                        >
                            <span
                                class="caption font-weight-medium"
                            >
                                {{ tab.text }}
                            </span>
                        </v-tab>
                    </v-tabs>
                    <v-spacer/>
                    <template v-if="selectedTab === 'person'">
                        <action-button
                            v-if="selected_account && can_edit_account(selected_account.id) && !selected_account.data.is_demo"
                            @click="onAddMemberClick"
                        >
                            {{ $t("Add member") }}
                        </action-button>
                    </template>
                    <template v-else>
                        <action-button
                            v-if="can_edit_account(selected_account.id) && !selected_account.data.is_demo"
                            @click="isEditGroupDialogOpen = true"
                        >
                            {{ $t("Add group") }}
                        </action-button>
                    </template>
                    <action-menu
                        v-if="selected_account && can_edit_account(selected_account.id) && !selected_account.data.is_demo"
                        :items="exportOptions"
                        icon="Download"
                        @action="exportOptions[$event].action()"
                    />
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col>
                    <RichDataTable
                        :rich-data-table-controller="richDataTableController"
                        force-show-footer
                    >
                        <template v-slot:item.avatar="{ item }">
                            <GroupAvatar
                                v-if="item.type === 'group'"
                                size="31"
                                :initials="item.initials"
                            />
                            <AccountAvatar
                                v-else
                                size="31"
                                :image-path="item.avatar"
                                :initials="item.initials"
                                :color="item.avatar ? 'white' : 'neutral_n40'"
                                text-color="neutral_n300"
                                text-class="font-weight-medium"
                            />
                        </template>
                        <template v-slot:item.role="{ item }">
                            {{ member_roles[item.role] }}
                        </template>
                        <template v-slot:item.status="{ item }">
                            {{ getFormattedStatus(item.status) }}
                        </template>
                        <template v-slot:item.edit="{ item }">
                            <div class="d-flex">
                                <v-spacer />
                                <action-button
                                    v-if="
                                        can_edit_not_owner_account(selected_account.id, item) &&
                                            ['pending', 'limited'].includes(item.status) &&
                                            !reinvite_sent_id_list.includes(item.id)
                                    "
                                    icon="Send"
                                    @click="onSendInviteClick(item)"
                                >
                                    {{ item.status === 'pending' ? $t("Resend invite") : $t('Send invite') }}
                                </action-button>
                                <v-tooltip
                                    v-if="can_edit_account(selected_account.id) && ['active', 'pending', 'limited'].includes(item.status) && item.type === 'person'"
                                    bottom
                                    open-delay="250"
                                >
                                    <template v-slot:activator="{ on }">
                                        <icon-button :on="on" icon="User" @click="$router.push({ name: 'profile_info', params: { personId: item.person_id, companyId: selected_account.id }})"/>
                                    </template>
                                    {{ $t('View profile') }}
                                </v-tooltip>
                                <v-tooltip
                                    v-if="item.type === 'person' && can_edit_not_owner_account(selected_account.id, item)"
                                    bottom
                                    open-delay="250"
                                >
                                    <template v-slot:activator="{ on }">
                                        <icon-button icon="Pencil" :on="on" @click="onEditMemberClick(item)"/>
                                    </template>
                                    <span class="white--text">{{ $t("Edit member") }}</span>
                                </v-tooltip>
                                <v-tooltip
                                    v-if="item.type === 'group' && can_edit_account(selected_account.id, item)"
                                    bottom
                                    open-delay="250"
                                >
                                    <template v-slot:activator="{ on }">
                                        <icon-button icon="Pencil" :on="on" @click="onEditGroupClick(item)"/>
                                    </template>
                                    <span class="white--text">{{ $t("Edit group") }}</span>
                                </v-tooltip>
                                <action-menu
                                    :items="actionItems"
                                    @action="actionItems[$event].action(item)"
                                />
                            </div>
                        </template>
                    </RichDataTable>
                </v-col>
            </v-row>
            <EditAccountMemberDialog
                v-if="isEditPersonDialogOpen"
                :company-id="selected_account.id"
                :person-id="editPersonId"
                @close="onCloseMemberEdit"
                @saved="urlAdapter.updateUrlParameters()"
                @clear-email-sent="reinvite_sent_id_list = reinvite_sent_id_list.filter(x => x !== $event)"
            />
            <GroupEditDialog
                v-if="isEditGroupDialogOpen"
                :show-dialog="isEditGroupDialogOpen"
                :account-id="selected_account.id"
                :group-id="editGroupId"
                @update="urlAdapter.updateUrlParameters()"
                @deleted="urlAdapter.updateUrlParameters()"
                @close="closeEditGroupClick"
            ></GroupEditDialog>
        </template>
        <template v-else>
            <div class="text-center mb-5 pb-5">
                <v-avatar
                    size="142"
                    color="white"
                    class="elevation-3 my-5"
                >
                    <img
                        alt=""
                        :src="baseUrl + '/static/img/users_heads.svg'"
                        style="height: 90px; width: auto; border-radius: 0"
                    />
                </v-avatar>
                <div
                    style="max-width: 428px; margin-right: auto; margin-left: auto;"
                    class="headline"
                >
                    {{ $t("To add members to your team, you'll need to create a company account") }}
                </div>
            </div>
            <CreateCompanyBlock></CreateCompanyBlock>
        </template>
    </div>
</template>

<script>
import ModernFilterBar from "@/components/ModernFilterBar/index.vue";
import {$t} from "@/i18n";
import {computed, reactive, ref, onMounted} from "@vue/composition-api";
import UserModule from "../../store/modules/user";
import AppModule from "@/store/modules/app";
import AccountModule from "../../store/modules/account";
import errorDialog from "@/views/ErrorDialog/errorDialog"
import RightsModule from "../../composables/use-rights";
import AccountAvatar from "../../components/AccountAvatar";
import {Router} from "@/composables/Router";
import {validateFeatureAllowed, FEATURE_ADD_COMPANY_MEMBERS} from "@/modules/subscription/allowed_features";
import FeedbackNotificationModule from "@/store/modules/feedback_notification";
import UrlAdapter from "@/urlAdapter/urlAdapter";
import RichDataTableController from "@/components/RichDataTable/RichDataTableController";
import EditAccountMemberDialog from "@/views/Dialog/EditAccountMemberDialog.vue";
import RichDataTable from "@/components/RichDataTable/RichDataTable.vue";
import FilterBarController from "@/components/ModernFilterBar/FilterBarController";
import GroupEditDialog from "@/views/Users/GroupEditDialog.vue";
import GroupAvatar from "@/components/GroupAvatar.vue";
import CreateCompanyBlock from "./CreateCompanyBlock";

export default {
    name: "UsersList",
    components: {
        GroupEditDialog,
        AccountAvatar,
        EditAccountMemberDialog,
        RichDataTable,
        ModernFilterBar,
        GroupAvatar,
        CreateCompanyBlock
    },
    setup() {
        const member_statuses = {
            active: $t("Active"),
            pending: $t("Invited"),
            inactive: $t("Inactive"),
        };
        const router = Router();
        const {baseUrl} = AppModule();
        const {showFeedbackNotification} = FeedbackNotificationModule();
        const reinvite_sent_id_list = ref([]);
        const {fetchAccountUsers, resendUserInvite, member_roles, allMembers} = UserModule();
        const {can_edit_account} = RightsModule();
        const {available_company_accounts, isFeatureEnabled} = AccountModule();
        const editPersonId = ref(null)
        const editGroupId = ref(null)
        const isEditPersonDialogOpen = ref(false)
        const isEditGroupDialogOpen = ref(false)
        const members = ref([])
        const totalMembers = ref(null)
        const activeTotalMembers = ref(null)

        let active_account = available_company_accounts.value && available_company_accounts.value.length ? available_company_accounts.value[0] : false;

        const options = [
            { key: "sortBy", default_value: "name" },
            { key: "sortDesc", default_value: false },
            { key: "itemsPerPage", default_value: 50 },
            { key: "page", default_value: 1 }
        ]

        const getFormattedStatus = (status) => {
            if (status === 'active') {
                return $t('Active')
            } else if (status === 'pending') {
                return $t('Invited')
            } else if (status === 'limited') {
                return $t('Limited')
            } else if (status === 'inactive') {
                return $t('Inactive')
            }
        }

        const getFilters = (value) => {
            if (value === 'group') {
                return [
                    {key: "account_id", default_value: urlAdapter.getUrlParameter('account_id') ? urlAdapter.getUrlParameter('account_id') : [active_account.id], items: available_company_accounts.value, default: true},
                ]
            } else {
                return [
                    {key: "account_id", default_value: urlAdapter.getUrlParameter('account_id') ? urlAdapter.getUrlParameter('account_id') : [active_account.id], items: available_company_accounts.value, default: true},
                    {key: "person_status", default_value: urlAdapter.getUrlParameter('person_status') ? urlAdapter.getUrlParameter('person_status') : ['visible'], default: true},
                ]
            }
        }

        const getHeaders = (value) => {
            if (value === 'group') {
                return [
                    { text: "", value: "avatar", sortable: false, align: "left pl-3", width: 31, default: true },
                    { text: $t("Name"), value: "name", default: true },
                    { text: $t("Members"), value: "members_count", sortable: false, default: true },
                    { text: "", value: "edit", sortable: false, align: "right", default: true }
                ]
            } else {
                let arr = [
                    {text: "", value: "avatar", sortable: false, align: "left pl-3", width: 31, default: true},
                    {text: $t("Name"), value: "name", default: true},
                    {text: $t("Email"), value: "email", default: true},
                    {text: $t("Role"), value: "role", default: true},
                    {text: $t("Status"), value: "status", default: true},
                    {text: $t("Clients"), sortable: false, value: "client_count", default: true},
                    {text: "", value: "edit", sortable: false, align: "right", default: true},
                    {text: $t("External ID"), sortable: false, value: "ext_user_id", default: true}
                ]
                return arr
            }
        }

        const isGroupSelected = computed(() => {
            return urlAdapter.getUrlParameter('member_type') ? urlAdapter.getUrlParameter('member_type')[0] === 'group' : null
        })

        const urlAdapter = new UrlAdapter()

        urlAdapter.addGetStateCallback((...args) => ({
            member_type: urlAdapter.getUrlParameter('member_type') ? urlAdapter.getUrlParameter('member_type') : 'person'
        }))

        const selectedTab = computed(() => {
            return urlAdapter.getUrlParameter('member_type') ? urlAdapter.getUrlParameter('member_type')[0] : 'person'
        })

        /** @type {FilterBarController} */
        const filterController = reactive(FilterBarController.init(urlAdapter))
        filterController.initFilters(getFilters(selectedTab.value))

        const defaultHeaders = getHeaders(selectedTab.value)

        /** @type {RichDataTableController} */
        const richDataTableController = reactive(RichDataTableController.init(defaultHeaders, options, urlAdapter))

        const exportOptions = computed(() => {
            let options = [];
            options.push({
                text: $t('Export') + " " + $t('Members').toLowerCase(),
                action: () => onExportMembersClick()
            })
            options.push({
                text: $t('Export') + " " + $t('Vacation').toLowerCase() + "/" + $t('Away').toLowerCase(),
                action: () => onExportMembersVacationsClick()
            })
            return options;
        });
        const onExportMembersClick = () => {
            const params = richDataTableController.urlAdapter.getFullQuery()
            window.open("/api/a/" + selectedCompanyId.value + "/users?is_export=1&" + params, "_top");
        };
        const onExportMembersVacationsClick = () => {
            const params = richDataTableController.urlAdapter.getFullQuery()
            window.open("/api/a/" + selectedCompanyId.value + "/member_vacation_export?is_export=1&" + params, "_top");
        };

        const selectedCompanyId = computed(() => {
            const selected_account_id_list = filterController.getValue('account_id') || urlAdapter.getUrlParameter('account_id')
            return selected_account_id_list ? parseInt(selected_account_id_list[0]) : null
        })
        const selected_account = computed(() => available_company_accounts.value.find(x => x.id === selectedCompanyId.value));

        const paidForUsersCount = computed(() => {
            return selected_account.value && selected_account.value.available_users_count ? selected_account.value.available_users_count : 1
        })

        const backendQuery = async (params) => {
            const accountId = params.account_id ? params.account_id : urlAdapter.getUrlParameter('account_id')

            const data = await fetchAccountUsers(accountId, {
                ...filterController.getCurrentFilterValues(),
                ...richDataTableController.getOptions(),
                include_active_total: true,
                include_group_member_count: true,
                member_type: params.member_type ? params.member_type : selectedTab.value
            });
            members.value = data.users
            totalMembers.value = data.total
            activeTotalMembers.value = data.active_total
            // these following two lines exist to show/hide "External ID" column when user switches selected account
            richDataTableController.setAllHeaders(getHeaders(selectedTab.value))
            await richDataTableController.setVisibleHeadersWithoutLoadData(getHeaders(selectedTab.value).map(x => x.value))
            richDataTableController.setRows(data.users, data.total)
        };

        richDataTableController.setLoadDataFunc(backendQuery)

        const can_edit_not_owner_account = (account_id, user) => {
            if (user.role === "owner") {
                return false;
            } else if (account_id && can_edit_account(account_id)) {
                return true;
            }
        };

        const onSendInviteClick = async (item) => {
            try {
                await resendUserInvite(item.person_id, item.company_id, item.name)
                reinvite_sent_id_list.value.push(item.id)
                const message = item.status === 'limited' ? $t('Invite sent') : $t('Re-invite sent')
                showFeedbackNotification(message)

                await urlAdapter.updateUrlParameters()
            } catch (e) {
                errorDialog.showError(e)
            }
        };
        const onAddMemberClick = () => {
            validateFeatureAllowed(FEATURE_ADD_COMPANY_MEMBERS, selected_account.value)
            onEditMemberClick({})
        };

        const onEditMemberClick = item => {
            editPersonId.value = item.person_id
            isEditPersonDialogOpen.value = true
        };

        const onEditGroupClick = (item) => {
            editGroupId.value = item.person_id
            isEditGroupDialogOpen.value = true
        }

        const actionItems = computed(() => {
            if (selectedTab.value === 'person') {
                return [
                    {
                        text: $t('View report'),
                        action: (item) => router.push({name: 'report', query: {person_id_list: item.person_id, view: 'detailed'}})
                    },
                ]
            }
        })

        const onCloseMemberEdit = () => {
            isEditPersonDialogOpen.value = false
            editPersonId.value = null
        }

        const closeEditGroupClick = () => {
            isEditGroupDialogOpen.value = false
            editGroupId.value = null
        }

        const tabs = computed(() => {
            return [
                {
                    text: $t("Members"),
                    value: "person"
                },
                {
                    text: $t("Groups"),
                    value: "group"
                }
            ]
        });

        const onTabSelected = async (value) => {
            const headers = getHeaders(value)
            filterController.initFilters(getFilters(value))
            richDataTableController.setAllHeaders(headers)
            await richDataTableController.setVisibleHeadersWithoutLoadData(headers.map(x => x.value))
            await urlAdapter.setUrlParameter('member_type', value)
        }

        filterController.startUrlWatcher()

        return {
            member_statuses,
            member_roles,
            selected_account,
            reinvite_sent_id_list,
            can_edit_account,
            can_edit_not_owner_account,
            onSendInviteClick,
            onEditMemberClick,
            onAddMemberClick,
            paidForUsersCount,
            selectedCompanyId,
            actionItems,
            exportOptions,
            allMembers,
            editPersonId,
            editGroupId,
            isEditPersonDialogOpen,
            onCloseMemberEdit,
            members,
            activeTotalMembers,
            totalMembers,
            richDataTableController,
            filterController,
            backendQuery,
            isEditGroupDialogOpen,
            closeEditGroupClick,
            onEditGroupClick,
            isGroupSelected,
            tabs,
            selectedTab,
            urlAdapter,
            onTabSelected,
            baseUrl,
            available_company_accounts,
            getFormattedStatus
        };
    }
};
</script>
